<button class="shortcut-menu__button" (click)="openSendConfigDialog()">
  <svg-icon src="assets/images/icons/send.svg"></svg-icon>
  <span>{{ "ShortcutMenu.SendConfig" | translate }}</span>
</button>
